import { Component } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MatSnackBar } from '@angular/material';
import { Subject } from 'rxjs/Subject';
import { ActivatedRoute, Router } from '@angular/router';
import { DocsService } from '../../../services/docs.service';
import { UtilsService } from '../../../services/utils.service';
import { debounceTime } from "rxjs/operators";

declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-doc-view',
  templateUrl: './doc-view.component.html',
  styleUrls: ['./doc-view.component.scss']
})

export class DocViewComponent {

  modelChanged: Subject<string> = new Subject<string>();

  doc = {
    title: '',
    body: '',
    id: ''
  };

  constructor(private apiService: ApiService,
              public snackBar: MatSnackBar,
              private route: ActivatedRoute,
              private router: Router,
              private graphqlService: DocsService,
              private utilsService: UtilsService) {
    this.modelChanged.pipe(
      debounceTime(1500)
    ).subscribe(model => { this.updateDoc(); });

    route.params.subscribe(params => {
      if (params['id']) {
        const id = params['id'];
        this.graphqlService.read(id).subscribe(result => {
          if (result && result.data) {
            console.log(result);
            this.doc = JSON.parse(JSON.stringify(result.data['document']));
            this.utilsService.openSnackBar('Data Loaded !!', '');
          }
        });
      }
    });
  }


  dataChanged() {
    this.modelChanged.next();
  }

  updateDoc() {
    this.graphqlService.update(this.doc).subscribe(res => {
      this.openSnackBar('Doc updated', '');
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {duration: 3000});
  }

  deleteDoc() {
    UIkit.modal($('#confirm-delete')).hide();
    $('#confirm-delete').remove();
    this.openSnackBar('Deleting doc', '');
    this.graphqlService.delete(this.doc).subscribe(res => {
      this.openSnackBar('Doc deleted', '');
      this.router.navigate(['/docs']);
    }, error => {
      this.utilsService.openSnackBar('Unable to delete document.', '');
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/docs/doc-view/doc-view.component.ts